/* eslint-disable default-case */

import Axios from "axios";
import _ from "lodash";
import Result from "./result";
import { context, propagation, trace } from "@opentelemetry/api";

import { API_BASE_URL } from "./constants";
import store from "redux/store"; // Import store đã cấu hình
import { setOpenNoInternetModal } from "redux/action";

const tracer = trace.getTracer("qr-order-web");

const requestWithTrace = (name, requestConfig, request) => {
  const span = tracer.startSpan(name);
  const activeContext = trace.setSpan(context.active(), span);
  const carrier = {};

  propagation.inject(activeContext, carrier);
  requestConfig.headers = {
    ...requestConfig.headers,
    ...carrier,
  };

  return context.with(activeContext, async () => {
    try {
      const response = await request(requestConfig);
      span.setAttribute("http.request.method", name.split(" ")[0]);
      span.setAttribute("http.response.status_code", response?.status || 200);
      span.end();
      return response;
    } catch (error) {
      span.recordException(error);
      span.setAttribute("error.type", error?.code || error?.name || "Error");
      span.end();
      throw error;
    }
  });
};

export const checkNetworkConnection = () => {
  // if ("connection" in navigator) {
  //   return navigator.connection.downlink;
  // }
  return navigator.onLine;
};

const updateOpenNoInternet = (isOpen) => {
  store.dispatch(setOpenNoInternetModal(isOpen));
};

export default class ServiceBase {
  static async requestJson(opts) {
    let axiosResult = null;
    let result = null;
    const axiosRequestConfig = {
      baseURL: opts.baseUrl || API_BASE_URL,
      timeout: opts.timeout || 30000,
      headers: {
        "Content-Type": _.get(opts, "contentType", "application/json"),
        Authorization: "Bearer ",
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        ResCode: opts?.restaurantCode
          ? opts?.restaurantCode
          : localStorage.getItem("restaurantCode"),
        AppCode: "QR_ORDER",
        ...opts.headers,
      },
    };
    try {
      switch (opts.method) {
        case "GET":
          axiosResult = await requestWithTrace(
            `GET ${opts.url}`,
            axiosRequestConfig,
            (requestConfig) =>
              Axios.get(opts.url, {
                ...requestConfig,
                params: opts.data,
              }),
          );
          break;
        case "POST":
          axiosResult = await requestWithTrace(
            `POST ${opts.url}`,
            axiosRequestConfig,
            (requestConfig) =>
              Axios.post(opts.url, opts.data, requestConfig),
          );
          break;
        case "PUT":
          axiosResult = await requestWithTrace(
            `PUT ${opts.url}`,
            axiosRequestConfig,
            (requestConfig) =>
              Axios.put(opts.url, opts.data, requestConfig),
          );
          break;
        case "DELETE":
          axiosResult = await requestWithTrace(
            `DELETE ${opts.url}`,
            axiosRequestConfig,
            (requestConfig) => Axios.delete(opts.url, requestConfig),
          );
          break;
        case "EXPORT":
          axiosResult = await requestWithTrace(
            `EXPORT ${opts.url}`,
            axiosRequestConfig,
            (requestConfig) =>
              Axios.get(`${opts.url}`, {
                ...requestConfig,
                responseType: "blob",
                params: opts.data,
              }),
          );
          break;
      }
      result = new Result(axiosResult.data, null);
    } catch (error) {
      console.log("error", error);
      const responseData = error?.response?.data;
      const normalizedValue =
        responseData && typeof responseData === "object"
          ? {
              ...responseData,
              code: String(
                responseData?.code ||
                  error?.response?.status ||
                  error?.code ||
                  ""
              ),
              message:
                responseData?.message ||
                responseData?.mess ||
                error?.message ||
                "",
              mess:
                responseData?.mess ||
                responseData?.message ||
                error?.message ||
                "",
              status: error?.response?.status,
            }
          : {
              code: String(error?.response?.status || error?.code || ""),
              message: error?.message || "",
              mess: error?.message || "",
              status: error?.response?.status,
              data: responseData,
            };

      result = new Result(normalizedValue, null);
      result.code = error?.code;
      result.message = error?.message;
      result.response = error?.response;
      return result;
    }
    return result;
  }
}
